namespace RioERP.Products {
    export interface CategoryForm {
        Name: Serenity.StringEditor;
        IsWebsiteCategory: Serenity.BooleanEditor;
        WebsiteCategoryId: Serenity.StringEditor;
        Description: Serenity.TextAreaEditor;
        ParentId: Serenity.LookupEditor;
    }

    export class CategoryForm extends Serenity.PrefixedContext {
        static formKey = 'Products.Category';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CategoryForm.init)  {
                CategoryForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;
                var w2 = s.TextAreaEditor;
                var w3 = s.LookupEditor;

                Q.initFormType(CategoryForm, [
                    'Name', w0,
                    'IsWebsiteCategory', w1,
                    'WebsiteCategoryId', w0,
                    'Description', w2,
                    'ParentId', w3
                ]);
            }
        }
    }
}
